// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".start-bg[data-v-2bba4003] {\n  background: linear-gradient(250.83deg, #a4bcff -3.45%, #dccdff 105.93%) !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
